<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>{{html_title}}使用说明:<br>
					<p v-html="html_note"></p>
				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

		</pre-base>

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Method_EasySelect,
		Method_SelColumn
	} from '@/utils/loadhttpdata.js';

	// import {
	//   BackSpecial
	// } from "@/utils/localstore.js";

	import {
		base_decode
	} from "@/utils/base64.js";

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_easy.vue")
		},
		data() {
			return {
				check_key: 'order_class',
				init_data: '',

				html_title: '',
				html_note: '',

				row_id: '',
				item: ''

			};
		},
		mounted: function() {
			// 保证首次加载完成时运行
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
				that.fun_note();
			});
		},
		created: function() {
			//在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，属性和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，$el 属性目前不可见。
			// console.log(' 自动构建 创建'); //发起ajax请求
		},
		// beforeUpdate: function() {
		//   //基于数据改变,影响页面  beforeUpdate 和 updated 当有更改数据才触发，beforeUpdate可以获取原DOM，updated可以获取更新DOM
		//   //改变前
		//   // console.log(document.body.innerHTML);
		// },
		// updated: function() {
		//   // 整体HTML 改变 就会执行
		// },
		// activated: function() {
		//   console.log('keep-alive 组件激活时调用 自动构建 激活');
		// },
		// destroyed: function() {
		//   //Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。
		//   // console.log(document.body.innerHTML);
		//   console.log('销毁'+this.check_key);
		// },
		methods: {
			init_view: function() {
				var that = this;
				// console.log('检测传参结果=' + this.check_key);
				this.$nextTick(function() {

					that.fun_init();
					that.fun_note();
				});
			},
			fun_init: function() {
				this.init_data = '';
				let that = this;
				if (this.check_key == '' || typeof(this.check_key) === 'undefined') {
					return;
				}

				this.$post(
					api.http_method, Method_EasySelect('_auto_build', 'auto_build', this.check_key)
				).then(res => {
					res = JSON.parse(res);

					// console.log(res.data.data);
					// console.log(JSON.stringify(res.data.data[0]))
					if (res.data.status == 1) {
						// this.list_class = [];
						// this.list_class = res.data.data;


						this.$nextTick(function() {

							that.init_data = JSON.stringify(res.data.data[0]);
						});
						// console.log(this.init_data);
						this.html_title = '';
						this.html_title = res.data.data[0].title;
					} else {
						this.$message.error(res.data.msg);
					}
				});

			},
			fun_note: function() {

				this.$post(
					api.http_method, Method_SelColumn('base_note', 0, this.check_key)
				).then(res => {
					res = JSON.parse(res);
					let temp_innerHtml = '';
					temp_innerHtml = base_decode(res.data);
					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>");
					// console.log(temp_innerHtml)
					this.html_note = temp_innerHtml;
				});

			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data();
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				// switch (type) {
				//   case 'father':
				//     // 弹出修改明细，修改主窗口信息
				//     this.refresh_data();
				//     break;
				//   default:
				//     // console.log('子组件刷新父组件传值=' + val);
				//     this.row_id = val;
				//     this.item = parm;
				//     break;
				// }
			}

		}
	};
</script>
